import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { duration: Number }

  connect() {
    this.dismiss = this.dismiss.bind(this)
    this.handleTransitionEnd = this.handleTransitionEnd.bind(this)
    this.dismissing = false

    requestAnimationFrame(() => {
      this.element.dataset.state = "visible"
    })

    this.timeout = window.setTimeout(this.dismiss, this.durationValue || 3000)
    this.element.addEventListener("transitionend", this.handleTransitionEnd)
  }

  disconnect() {
    window.clearTimeout(this.timeout)
    this.element.removeEventListener("transitionend", this.handleTransitionEnd)
  }

  dismiss() {
    if (this.dismissing) return

    this.dismissing = true
    this.element.dataset.state = "leaving"
    window.setTimeout(() => this.remove(), 250)
  }

  handleTransitionEnd(event) {
    if (!this.dismissing) return
    if (event.target !== this.element) return

    this.remove()
  }

  remove() {
    if (!this.element.isConnected) return

    this.element.remove()
  }
}
